var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NeoButton,{staticStyle:{"width":"40px"},attrs:{"no-shadow":"","icon-left":"gift","icon-pack":"fas","tag":"nuxt-link","to":`/${_setup.urlPrefix}/transfer?target=${_setup.props.address}&usdamount=10&donation=true`}})
}
var staticRenderFns = []

export { render, staticRenderFns }